export function ShowByGroupID(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/contact-info`;
}

export function Upsert(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/contact-info`;
}

